<template>
    <!-- 路由出口：登录/绑定/业务页面均在此渲染 -->
    <router-view />
</template>

<script setup lang="ts">
defineOptions({ name: 'App' });
</script>

<style scoped></style>
